import React, { FC, ReactElement, useState } from 'react';

import { useRecoilValue } from 'recoil';

import { showSideMenuAtom } from '@recoil_iqfu/atoms/side_menu/showSideMenu';

import DashboardMainArea from '@components_common/dashboard_main_area/DashboardMainArea';
import ProtectedRoutes from '@components_common/protected_routes/ProtectedRoutes';
import AdminSideMenu from '@components_common/side_menu/AdminSideMenu';
import CompanySideMenu from '@components_common/side_menu/CompanySideMenu';
import FinancialAgencySideMenu from '@components_common/side_menu/FinancialAgencySideMenu';
import { UserType } from '@constants_common';

import styles from './DashboardPageContainer.module.scss';

type Props = {
  userType: UserType;
  rightColumn?: ReactElement;
};
const DashboardPageContainer: FC<Props> = ({ userType, rightColumn, children }) => {
  const showSideMenu = useRecoilValue(showSideMenuAtom);
  const [spMenuOpen, setSpMenuOpen] = useState(false);
  const toggleSpMenu = () => {
    setSpMenuOpen(!spMenuOpen);
  };

  return (
    <ProtectedRoutes userType={userType}>
      <div className={styles.container}>
        <div className={`${styles.side_menu} ${userType === 'admin' && !showSideMenu ? styles.hides_side_menu : ''}`}>
          {userType === 'company' && <CompanySideMenu toggleSpMenu={toggleSpMenu} spMenuOpen={spMenuOpen} />}
          {userType === 'admin' && <AdminSideMenu toggleSpMenu={toggleSpMenu} spMenuOpen={spMenuOpen} />}
          {userType === 'financial_agency' && (
            <FinancialAgencySideMenu toggleSpMenu={toggleSpMenu} spMenuOpen={spMenuOpen} />
          )}
        </div>
        {!spMenuOpen && (
          <DashboardMainArea userType={userType} hasRightColumn={!!rightColumn}>
            {children}
          </DashboardMainArea>
        )}
        <>{rightColumn}</>
      </div>
    </ProtectedRoutes>
  );
};

export default DashboardPageContainer;
